import { Box, Grid } from '@mui/material';

import { SettingsHeader } from '../../../../components/SettingsHeader';
import { WsBreadCrumbs } from '../../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../../features/teams/helper/defaultValues';
import WsSmtpSetup from '../../WsSmtpSetup';

import SignatureContent from './signatureContent';
const EmailSignature = () => {
  return (
    <Box borderRadius={1.5}>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
          Pages['EMAIL_SETTINGS']
        )}
      />
      <SettingsHeader title="Email Settings" />
      <Grid container spacing={2}>
        <Grid marginTop={2} item xs={2.5} pl={0} borderRadius={1.5}>
          <WsSmtpSetup />
        </Grid>
        <Grid marginTop={2} item xs={9.5}>
          <SignatureContent />
        </Grid>
      </Grid>
    </Box>
  );
};
export default EmailSignature;
